// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 9030 ? "23b2023c" : chunkId) + "." + {"2275":"ba3a94b00acb1946","9030":"624d80b97559ecce"}[chunkId] + ".js";
};